/**
 * Created by iamso on 16.08.2021
 */

const RestoreProgress = function () {
    this.onUpdate = function () {};
    this.onRemove = function () {};

    this.opened = false;

    this.onceRestoreFinished = undefined;

    cleverapps.meta.on("progressChanged", () => this.update());

    this.update();
};

RestoreProgress.prototype.isAvailable = function () {
    if (cleverapps.config.adminMode || cleverapps.config.editorMode) {
        return false;
    }

    if (!connector.social.isConnected() || cleverapps.flags.nologin || connector.social.isLoggedIn()) {
        return false;
    }

    return !cleverapps.user.checkAvailable(cleverapps.config.availables.RESTORE_PROGRESS);
};

RestoreProgress.prototype.isOpened = function () {
    return this.opened;
};

RestoreProgress.prototype.isVisible = function () {
    return (cleverapps.environment.isMainScene()
            || cleverapps.environment.isGameScene()
            || cleverapps.environment.isComicsScene())
        && !this.isOpened();
};

RestoreProgress.prototype.update = function () {
    if (!this.isAvailable()) {
        this.onRemove();
    } else {
        this.onUpdate();
    }
};

RestoreProgress.prototype.restore = function () {
    if (cleverapps.focusManager.currentWindow() instanceof SignInWindow) {
        return;
    }

    cleverapps.focusManager.display({
        focus: "RestoreProgress",
        stack: true,
        keepControls: true,
        actions: [
            (f) => {
                this.opened = true;
                this.update();

                new SignInWindow({
                    restoreProgress: true,

                    onSuccess: () => {
                        this.opened = false;
                        f();
                    },

                    onFailure: () => {
                        this.opened = false;
                        f();
                    }
                });
            },

            (f) => {
                this.update();
                f();

                if (this.onceRestoreFinished) {
                    const callback = this.onceRestoreFinished;
                    this.onceRestoreFinished = undefined;
                    callback();
                }
            }
        ]
    });
};
